import { render, staticRenderFns } from "./AddChildrenAuth.vue?vue&type=template&id=3b3f3fc0&scoped=true"
import script from "./AddChildrenAuth.vue?vue&type=script&lang=js"
export * from "./AddChildrenAuth.vue?vue&type=script&lang=js"
import style0 from "./AddChildrenAuth.vue?vue&type=style&index=0&id=3b3f3fc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3f3fc0",
  null
  
)

export default component.exports